import * as requestServices from "../request"
import moment from 'moment';

export const req = {
    getAllCategories(url, firmId) {
        return requestServices.get(url + '/' + firmId)
        .then((data) => (data))
        .then((res)=> {
          //console.log(res);
          // let cat_order = 1;
          // let updateCatOrder = false;
          // if (res.every((el) => el.cat_Order == 0)) {
          //   updateCatOrder = true;
          // }
          res.map((item) => { 
            item.updated_on = moment(item.updated_on, "YYYY-MM-DDTHH:mm:ss.SSS").format("MM/DD/YY");
            // if (updateCatOrder) {
            //   item.cat_Order = cat_order++;
            // }
            return item;
          });
          return res;
        });
    },

    getActiveCategories(url, firmId) {
      return requestServices.get(url + '/' + firmId)
      .then((data) => (data))
      .then((res)=> {
        //console.log(res);
        // let cat_order = 1;
        // let updateCatOrder = false;
        // if (res.every((el) => el.cat_Order == 0)) {
        //   updateCatOrder = true;
        // }
        res.map((item) => { 
          item.updated_on = moment(item.updated_on, "YYYY-MM-DDTHH:mm:ss.SSS").format("MM/DD/YY");
          // if (updateCatOrder) {
          //   item.cat_Order = cat_order++;
          // }
          return item;
        });
        return res;
      });
    },

    getTaskCount(url,firmId,catId){
      return requestServices.get(url + '/' + firmId + '/' + catId)
      .then((data) => (data))
      .then((res)=> {
        // res.map((item) => { 
        //   console.log(item)
        //   // item.updated_on = moment(item.updated_on, "YYYY-MM-DDTHH:mm:ss.SSS").format("MM/DD/YY");
        //   // return item;
        // });
        return res;
      });
  },

    setAllCategories(url, data) {
      //console.log("SET ALL CATEGORIES : ", data)
      return requestServices.put(url, data)
      .then((data) => (data))
      .then((res) => {
        return res;
      });
    },
    
    addCategory(url, data){
      //console.log("ADD CATEGORY SERVICE : ", url , data);
      return requestServices.post(url,data)
      .then((data) => (data))
      .then((res) => {
        /*
        res.map((item) => { 
          item.updated_on = moment(item.updated_on, "YYYY-MM-DDTHH:mm:ss.SSS").format("MM/DD/YY");
          return item;
        });
        */
          res.map((res) => {
              res.updated_on = moment(res.updated_on, "YYYY-MM-DDTHH:mm:ss.SSS").format("MM/DD/YY");
              res.updated_byName = data.updated_byName;
          });
        return res;
      })
    }
}

